export default [
	{
		path: 'real-talk',
		name: 'real-talk',
		component: () => import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/RealTalk.vue'),
		meta: {
			hideHeader: true,
			hideProgress: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingRealTalkScreen'
				}
			}
		}
	},
	{
		path: 'like-to-feel',
		name: 'like-to-feel',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/LikeToFeel.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingLikeToFeelScreen'
				}
			}
		}
	},
	{
		path: 'like-to-boost',
		name: 'like-to-boost',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/LikeToBoost.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingLikeToBoostScreen'
				}
			}
		}
	},
	{
		path: 'at-happy-weight',
		name: 'at-happy-weight',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/AtHappyWeight.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingAtHappyWeightScreen'
				}
			}
		}
	},
	{
		path: 'see-myself-screen',
		name: 'see-myself-screen',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/SeeMyselfScreen.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingSeeMyselfScreen'
				}
			}
		}
	},
	{
		path: 'main-reason',
		name: 'main-reason',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/MainReason.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingMainReasonScreen'
				}
			}
		}
	},
	{
		path: 'current-priorities',
		name: 'current-priorities',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/CurrentPriorities.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingCurrentPrioritiesScreen'
				}
			}
		}
	},
	{
		path: 'gain-weight-reason',
		name: 'gain-weight-reason',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/GainWeightReason.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingGainWeightReasonScreen'
				}
			}
		}
	},
	{
		path: 'last-happy-weight',
		name: 'last-happy-weight',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/LastHappyWeight.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingLastHappyWeightScreen'
				}
			}
		}
	},
	{
		path: 'weight-loss-apps',
		name: 'weight-loss-apps',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/WeightLossApps.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingWeightLossAppsScreen'
				}
			}
		}
	},
	{
		path: 'weight-loss-attempts',
		name: 'weight-loss-attempts',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/WeightLossAttempts.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingWeightLossAttemptsScreen'
				}
			}
		}
	},
	{
		path: 'mental-health-services',
		name: 'mental-health-services',
		component: () =>
			import(
				/* webpackChunkName: "bulk-screens" */
				'@/views/survey/experiments/DEV-1865/MentalHealthServices.vue'
			),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingMentalHealthServicesScreen'
				}
			}
		}
	},
	{
		path: 'motivation-to-lose-weight',
		name: 'motivation-to-lose-weight',
		component: () =>
			import(
				/* webpackChunkName: "bulk-screens" */
				'@/views/survey/experiments/DEV-1865/MotivationToLoseWeight.vue'
			),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingMotivationToLoseWeightScreen'
				}
			}
		}
	},
	{
		path: 'understanding-mindset',
		name: 'understanding-mindset',
		component: () =>
			import(
				/* webpackChunkName: "bulk-screens" */
				'@/views/survey/experiments/DEV-1865/UnderstandingMindset.vue'
			),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingUnderstandingMindsetScreen'
				}
			}
		}
	},
	{
		path: 'confidence-in-reaching',
		name: 'confidence-in-reaching',
		component: () =>
			import(
				/* webpackChunkName: "bulk-screens" */
				'@/views/survey/experiments/DEV-1865/ConfidenceInReaching.vue'
			),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingConfidenceInReachingScreen'
				}
			}
		}
	},
	{
		path: 'what-make-uncertain',
		name: 'what-make-uncertain',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/WhatMakeUncertain.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingWhatMakeUncertainScreen'
				}
			}
		}
	},
	{
		path: 'weight-loss-goal',
		name: 'weight-loss-goal',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/WeightLossGoal.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingWeightLossGoalScreen'
				}
			}
		}
	},
	{
		path: 'weight-loss-goals',
		name: 'weight-loss-goals',
		component: () => import(/* webpackChunkName: "srv" */ '@/views/survey/WeightLossGoals.vue'),
		meta: {
			oneSectionProgress: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingWeightLossGoalScreen'
				}
			}
		}
	},
	{
		path: 'eating-habits',
		name: 'eating-habits',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/EatingHabits.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingEatingHabitsScreen'
				}
			}
		}
	},
	{
		path: 'snacking-triggers',
		name: 'snacking-triggers',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/SnackingTriggers.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingSnackingTriggersScreen'
				}
			}
		}
	},
	{
		path: 'more-to-explore',
		name: 'more-to-explore',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/MoreToExplore.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingMoreToExploreScreen'
				}
			}
		}
	},
	{
		path: 'typical-day',
		name: 'typical-day',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/TypicalDay.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingTypicalDayScreen'
				}
			}
		}
	},
	{
		path: 'typical-meal',
		name: 'typical-meal',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/TypicalMeal.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingTypicalMealScreen'
				}
			}
		}
	},
	{
		path: 'your-plan-ready',
		name: 'your-plan-ready',
		component: () =>
			import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/YourPlanReady.vue'),
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingPlanReadyScreen'
				}
			}
		}
	},
	{
		path: 'great-job',
		name: 'great-job',
		component: () => import(/* webpackChunkName: "bulk-screens" */ '@/views/survey/experiments/DEV-1865/GreatJob.vue'),
		meta: {
			hideHeader: true,
			hideProgress: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingGreatJobScreen'
				}
			}
		}
	}
]
